import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import React, {forwardRef, useEffect} from "react";
import {useAppSelector} from "redux/hooks";
import {TRANG_THAI_MUA_SAM} from "types/enums/shopping";
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};
const {xs, sm, md, xl, lg} = css;
const ModalApprove = forwardRef((props: any, ref) => {
  const {submit, closeModal, isLoading} = props;
  const [form] = Form.useForm();
  const {detailProposePay} = useAppSelector(state => state.proposeShopping);
  const submitApprove = async () => {
    try {
      await form.validateFields();
      const nguoiDuyet = getNguoiDuyet(detailProposePay?.trangThai);
      console.log(form.getFieldsValue());
      console.log(nguoiDuyet);
      submit(
        {
          nguoiDuyet: nguoiDuyet,
          trangThai: detailProposePay?.trangThai + 1,
        },
        "Đã phê duyệt đề nghị"
      );
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };
  const getNguoiDuyet = trangThai => {
    let nguoiDuyetTiepTheo = "";
    switch (trangThai) {
      case TRANG_THAI_MUA_SAM.CHO_DUYET:
        nguoiDuyetTiepTheo = form.getFieldValue("ktduyet");
        break;
      case TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET:
        nguoiDuyetTiepTheo = form.getFieldValue("bgdduyet");
        break;
      case TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET:
      // nguoiDuyetTiepTheo = form.getFieldValue("bgdduyet");
      default:
        break;
    }
    return nguoiDuyetTiepTheo;
  };
  useEffect(() => {
    const setFieldsValues = detailProposePay => {
      form.setFieldValue("tbpduyet", detailProposePay?.tbpduyet);
      form.setFieldValue("ktduyet", detailProposePay?.ktduyet);
      form.setFieldValue("bgdduyet", detailProposePay?.bgdduyet);
    };
    setFieldsValues(detailProposePay);
  }, [detailProposePay]);

  return (
    <Spin spinning={isLoading}>
      <>
        <Typography.Text strong>Người phê duyệt</Typography.Text>
        <Form form={form} style={{marginTop: 15}}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row justify={"space-between"} gutter={[8, 8]}>
              <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                <Form.Item>
                  <Input disabled={true} value={"Trưởng bộ phận"}></Input>
                </Form.Item>
              </Col>

              <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                <Form.Item
                  name="tbpduyet"
                  rules={[{required: true, message: "Bắt buộc nhập"}]}
                >
                  <Input disabled={true}></Input>
                </Form.Item>
              </Col>
            </Row>
            {detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET && (
              <Typography.Text strong>
                Chọn người duyệt bước tiếp theo
              </Typography.Text>
            )}
            {(detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET ||
              detailProposePay?.trangThai ==
                TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
              detailProposePay?.trangThai ==
                TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
              <Row justify={"space-between"} gutter={[8, 8]}>
                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item>
                    <Input disabled={true} value={"Kế toán"}></Input>
                  </Form.Item>
                </Col>

                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item
                    name="ktduyet"
                    rules={[{required: true, message: "Bắt buộc nhập"}]}
                  >
                    <Input
                      disabled={
                        detailProposePay?.trangThai !=
                        TRANG_THAI_MUA_SAM.CHO_DUYET
                      }
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {detailProposePay?.trangThai ==
              TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET && (
              <Typography.Text strong>
                Chọn người duyệt bước tiếp theo
              </Typography.Text>
            )}
            {(detailProposePay?.trangThai ==
              TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
              detailProposePay?.trangThai ==
                TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
              <Row justify={"space-between"} gutter={[8, 8]}>
                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item>
                    <Input disabled={true} value={"Ban giám đốc"}></Input>
                  </Form.Item>
                </Col>

                <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
                  <Form.Item
                    name="bgdduyet"
                    rules={[{required: true, message: "Bắt buộc nhập"}]}
                  >
                    <Input
                      disabled={
                        detailProposePay?.trangThai !=
                        TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET
                      }
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Space>
        </Form>
      </>
      <Row justify={"end"} style={{marginTop: 8}}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>{" "}
          <Button type="primary" onClick={submitApprove}>
            Phê duyệt
          </Button>
        </Space>
      </Row>
    </Spin>
  );
});

export default ModalApprove;
